import * as api from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionType = "RETTEKODER";
const metaData = { entitet: "Rettekode", notify: true };

export function getRettekoder() {
  return axiosUtils.GetAll(api.GET_RETTEKODER_URL, actionType);
}

export function postRettekode(payload) {
  return axiosUtils.Post(api.POST_RETTEKODE_URL, payload, actionType, metaData);
}

export function putRettekode(payload) {
  return axiosUtils.Put(
    api.PUT_RETTEKODE_URL(payload.id),
    payload,
    actionType,
    metaData,
  );
}
